import { environment } from '../../environments/environment';

export class AppUrls {
  // -----------------------------------
  // Developer settings
  // -----------------------------------

  private static readonly urlNGROK = 'https://roesberg.liveforms.ngrok.io/';
  //private static urlDEMO = 'https://livedokweb.roesberg.com:8400/';
  private static readonly urlDEMO = 'https://liveformsweb.roesberg.com/';
  private static readonly urlLOCALANGULAR = 'https://localhost:4200';
  private static readonly urlLOCALAPI = 'https://localhost:7129/';

  // who delivers Angular in development
  static readonly useLocalAngular = true; // true for local angular development server (most cases), false for remote server

  // who delivers backend in development
  static readonly useDemoForDevelopmentAPI = false; // true for Roesberg Online Demo
  static readonly useNGROKForDevelopmentAPI = false; // true for NGROK else localhost

  // -----------------------------------

  static baseUrlAngular = AppUrls.getBaseUrlAngular();
  static actionSilentRefresh = 'silent-refresh.html';

  static baseUrlMvc = AppUrls.getBaseUrlMvc();

  static urlApi = 'api/';

  static urlAuth = 'authorization/';
  static actionAuthPswChange = 'ChangePassword';
  static actionAuthLogin = 'Authorize';
  static actionAuthLogout = 'Logout';
  static actionAuthToken = 'Token';
  static actionAuthUserInfo = 'UserInfo';
  static actionAuthSessionCheck = 'CheckSession';

  static urlConnect = 'connect/';
  static urlDocument = 'document';
  static actionConnectRevocation = 'revocation';

  static urlMessage = 'message';

  static urlProjects = 'projects';

  static urlOrders = 'orders';
  static urlForms = 'forms';

  static urlSettings = 'settings';
  static urlTempImages = 'images/temp/';
  private static readonly urlLogout = 'logout';
  static urlCloseWindow = 'home/closewindow';

  static getBaseUrlAngular(): string {
    // in production, we always use the origin of the current window
    if (environment.production) {
      return window.location.origin;
    }

    // in development, we could also use a remote angular server
    if (!this.useLocalAngular) {
      if (this.useDemoForDevelopmentAPI) {
        return this.urlDEMO;
      }
      if (this.useNGROKForDevelopmentAPI) {
        return this.urlNGROK;
      }
    }
    // local angular development server
    return this.urlLOCALANGULAR;
  }

  static getBaseUrlMvc(): string {
    // in production, we always use the origin of the current window
    if (environment.production) {
      return window.location.origin + '/';
    }
    // for development, we can use remote server to deliver API
    if (this.useDemoForDevelopmentAPI) {
      return this.urlDEMO;
    }
    if (this.useNGROKForDevelopmentAPI) {
      return this.urlNGROK;
    }
    // local API development server
    return this.urlLOCALAPI;
  }

  static getLogoutUrl(): string {
    return this.getBaseUrlMvc() + this.urlLogout;
  }

  static getApiUrl(path: string, action: string | undefined = undefined): string {
    let result = this.baseUrlMvc + this.urlApi + path;
    if (action != undefined && action !== '') {
      result = result + '/' + action;
    }
    return result;
  }

  static getAuthUrl(urlAction: string): string {
    return this.baseUrlMvc + this.urlAuth + urlAction;
  }

  static getConnectUrl(urlAction: string): string {
    return this.baseUrlMvc + this.urlConnect + urlAction;
  }

  static getImageUrl(image: string): string {
    return this.baseUrlMvc + this.urlTempImages + image;
  }

  static getAssetsUrl(asset: string): string {
    return 'assets/' + asset;
  }

  static urlMatchIdentity(url: string): boolean {
    // literal syntax for RegExp expression in JS to test if the URL is absolute (starts with http:// or https://)
    const isAbsolute = /^https?:\/\//i.test(url);

    // relative URLs are never identity URLs
    if (!isAbsolute) {
      return false;
    }

    const urlOrigin = new URL(url).origin;
    if (urlOrigin === new URL(AppUrls.getBaseUrlMvc()).origin) {
      return false;
    }

    // external URLs are identity URLs if they do not match the API URL (BaseUrlMvc)
    return urlOrigin !== window.location.origin;
  }
}
